import script from "./ShowErrorLoading.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShowErrorLoading.vue?vue&type=script&setup=true&lang=ts"

import "./ShowErrorLoading.vue?vue&type=style&index=0&id=3bb841c7&scoped=true&lang=css"

import exportComponent from "/Users/samuel/KTH/DynWeb/ssoderbe-wrmvd-ht22-project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bb841c7"]])

export default __exports__